import { useEffect, useState } from 'react';

interface MaterialIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  /**
   * Material Symbolsのアイコン名
   * 例: 'close', 'check', 'person', 'description'
   */
  name: string;
  /**
   * 追加のCSSクラス名
   */
  className?: string;
  /**
   * インラインスタイル
   */
  style?: React.CSSProperties;
  /**
   * 塗りつぶし（Material SymbolsのFILL軸）を有効にする
   */
  filled?: boolean;
}

/**
 * Material Symbolsフォントを使用したアイコンコンポーネント
 * フォントロード完了まで非表示にすることで、文字が表示される問題を防ぎます
 */
export const MaterialIcon = ({
  name,
  className = '',
  style = {},
  filled = false,
  ...rest
}: MaterialIconProps) => {
  const [fontLoaded, setFontLoaded] = useState(false);

  useEffect(() => {
    document.fonts.ready.then(() => {
      setFontLoaded(true);
    });
  }, []);

  return (
    <span
      className={`material-symbols-outlined ${className}`}
      style={{
        ...(filled ? { fontVariationSettings: "'FILL' 1" } : {}),
        ...style,
        visibility: fontLoaded ? 'visible' : 'hidden',
      }}
      {...rest}
    >
      {name}
    </span>
  );
};
